<template>
  <header class="relative">
    <nav
      class="sticky top-[70px] z-40 bg-[#f7f8fb] mx-auto max-w-7xl px-6 pt-6 md:pt-10 flex items-center justify-between"
    >
      <a href="#" class="flex items-center gap-3">
        <span
          class="inline-flex h-8 w-8 items-center justify-center rounded-md bg-white ring-1 ring-neutral-200 shadow-sm"
        >
          <Sparkles :size="16" class="text-emerald-500" />
        </span>
        <span class="text-[15px] tracking-tight text-neutral-900">
          {{ name }}
        </span>
      </a>
      <div class="hidden md:flex items-center gap-7 text-sm text-neutral-600">
        <a
          href="#intro"
          class="hover:text-neutral-900 hover:underline underline-offset-4 transition-colors"
          @click.prevent="scrollTo('#intro')"
        >
          Introduction
        </a>
        <a
          href="#education"
          class="hover:text-neutral-900 hover:underline underline-offset-4 transition-colors"
          @click.prevent="scrollTo('#education')"
        >
          Education
        </a>
        <a
          href="#uiux"
          class="hover:text-neutral-900 hover:underline underline-offset-4 transition-colors"
          @click.prevent="scrollTo('#uiux')"
        >
          UI/UX
        </a>
        <a
          href="#graphics"
          class="hover:text-neutral-900 hover:underline underline-offset-4 transition-colors"
          @click.prevent="scrollTo('#graphics')"
        >
          Graphics
        </a>
        <a
          href="#contact"
          class="hover:text-neutral-900 hover:underline underline-offset-4 transition-colors"
          @click.prevent="scrollTo('#contact')"
        >
          Contact
        </a>
        <button
          @click="openCVPreview"
          class="inline-flex items-center gap-2 rounded-md bg-neutral-900 text-white px-3 py-2 ring-1 ring-neutral-900/10 hover:bg-neutral-800 transition"
        >
          <Download :size="16" />
          <span>Download CV</span>
        </button>
      </div>
      <!-- Mobile Download CV Button -->
      <button
        @click="openCVPreview"
        class="md:hidden inline-flex items-center gap-2 rounded-md bg-neutral-900 text-white px-3 py-2 ring-1 ring-neutral-900/10 hover:bg-neutral-800 transition"
      >
        <Download :size="16" />
        <span class="text-sm">CV</span>
      </button>
    </nav>

    <!-- CV Preview Modal -->
    <CVPreviewModal
      :is-open="showCVModal"
      :cv-url="cvUrl"
      :cv-download-url="cvDownloadUrl"
      @close="closeCVPreview"
    />

    <!-- Hero -->
    <section class="relative mx-auto max-w-7xl px-6 pt-16 md:pt-24 pb-12">
      <div class="grid lg:grid-cols-12 gap-10 items-end">
        <div class="lg:col-span-8">
          <p class="text-sm uppercase tracking-[0.22em] text-neutral-500">
            MY
          </p>
          <h1
            class="mt-4 text-[16vw] leading-none md:text-[10rem] font-semibold tracking-tight text-neutral-900"
          >
            PORTFOLIO
          </h1>
          <div class="mt-6 flex items-center gap-4 text-neutral-700">
            <div class="inline-flex items-center gap-2">
              <PenTool :size="20" class="text-emerald-600" />
              <span class="text-[15px]">Product Designer</span>
            </div>
            <div class="inline-flex items-center gap-2">
              <Palette :size="20" class="text-sky-600" />
              <span class="text-[15px]">Art Direction</span>
            </div>
          </div>
        </div>
        <!-- <div class="lg:col-span-4 flex lg:justify-end">
          <div
            class="relative rounded-2xl overflow-hidden ring-1 ring-neutral-200 bg-white w-full max-w-sm shadow-sm"
          >
            <img
              :src="portraitImage"
              alt="Portrait"
              class="h-72 w-full object-cover"
            />
            <div
              class="absolute inset-0 bg-gradient-to-t from-white/60 to-transparent"
            ></div>
            <div class="absolute bottom-0 p-5">
              <p class="text-neutral-900 font-medium">{{ name }}</p>
              <p class="text-sm text-neutral-600">
                Designer & Visual Storyteller
              </p>
            </div>
          </div>
        </div> -->
      </div>
      <div class="mt-10 flex items-center gap-3 text-neutral-500">
        <ArrowDown :size="16" />
        <span class="text-sm">Scroll to explore</span>
      </div>
    </section>
  </header>
</template>

<script>
import { Sparkles, Download, PenTool, Palette, ArrowDown } from 'lucide-vue-next'
import CVPreviewModal from './CVPreviewModal.vue'

export default {
  name: 'UIUXHero',
  components: {
    Sparkles,
    Download,
    PenTool,
    Palette,
    ArrowDown,
    CVPreviewModal
  },
  props: {
    name: {
      type: String,
      default: 'Your Name'
    },
    portraitImage: {
      type: String,
      default: 'https://images.unsplash.com/photo-1621619856624-42fd193a0661?w=1080&q=80'
    },
    cvUrl: {
      type: String,
      default: ''
    },
    cvDownloadUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showCVModal: false
    }
  },
  methods: {
    scrollTo(selector) {
      const element = document.querySelector(selector)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    },
    openCVPreview() {
      this.showCVModal = true
    },
    closeCVPreview() {
      this.showCVModal = false
    }
  }
}
</script>

